import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {Image} from '@app/components/Image';

export const Monetization: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['remuneration']});
	return (
		<LandingIllustrationSection
			description={
				<>
					<Image
						priority
						aspectRatio="516/363"
						maxW={{base: '285px'}}
						sizes="50vw"
						src="6fa9103d4ed8023253caadfc78529f70.png"
						alt="fraud"
					/>
					<LandingHeading as="h2" maxWidth="550px">
						{t(
							'acpslandingpage_title_empoweringartistsinstreaming_standalone-web',
						)}
					</LandingHeading>
					<LandingParagraph
						maxWidth="550px"
						color="text.neutral.primary.default"
					>
						{t(
							'acpslandingpage_text_empoweringartistsinstreaming_standalone-web',
						)}
					</LandingParagraph>
				</>
			}
		/>
	);
};
